import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../cn.ts";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-heading font-bold uppercase tracking-wide",
  {
    variants: {
      variant: {
        rank: "bg-[var(--brand-rose)] text-white",
        free: "bg-[var(--brand-pink)] text-[var(--brand-ink)]",
        locked: "bg-[var(--brand-ink)] text-white",
        muted: "bg-[var(--brand-pink-soft)] text-[var(--brand-muted)]",
      },
    },
    defaultVariants: { variant: "muted" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...rest }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...rest} />;
}
